import * as React from 'react';
import { usePersonDevicesModel } from '../hooks';
import { ActorApiStringDisplay } from '../../../../../components/display/string';

export const PersonsDevicesModel = () => {
  const {
    data,
    isLoading,
    error,
  } = usePersonDevicesModel();
  return (
    <ActorApiStringDisplay
      data={data}
      isLoading={isLoading}
      error={error}
    />
  );
};
